<template>
  <div class="box">
    <el-container class="login-box">
      <el-header class="header">后台管理系统</el-header>
      <el-main class="form-box">
        <div class="form">
          <el-input class="field" placeholder="请输入账号" prefix-icon="el-icon-user" v-model="username" />
          <el-input class="field" placeholder="请输入密码" type="password" prefix-icon="el-icon-lock" v-model="password" />
          <el-button class="field" type="primary" @click="doLogin">登录</el-button>
        </div>
      </el-main>
    </el-container>
    <div class="icp-box">
      <p class="description">Copyright © 2013-2021 www.whaledge.com. All Rights Reserved 鲸识（上海）信息科技有限公司
        沪ICP备2021015986号</p>
      <a class="description" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502017960">沪公网安备
        31011502017960号</a>
    </div>
  </div>
</template>

<script>
import {AdminRequestUtil} from '../utils/AdminRequestUtil'

export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    doLogin () {
      let that = this
      if (this.username.length < 5 || this.password.length < 6) {
        this.$message({
          message: '账号或密码不正确',
          type: 'warning'
        })
      } else {
        AdminRequestUtil.login({
          username: this.username,
          password: this.password
        }, function (response) {
          if (response.token) {
            that.$cookies.set('token', response.token, '1D')
            window.location.reload()
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.box {
  /*background-image: linear-gradient(#222, #666);*/
  background-image: url("/static/imgs/bg2.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;

  .login-box {
    width: 100%;
    position: absolute;
    top: 20%;
    color: #fff;
    text-align: center;

    .header {
      font-size: 30px;
    }

    .form-box {
      text-align: center;

      .form {
        display: inline-block;
        width: 300px;

        .field {
          width: 100%;
          margin-top: 15px;
        }
      }
    }
  }

  .icp-box {
    position: absolute;
    width: 100%;
    height: 100px;
    text-align: center;
    bottom: 20px;
    left: 0;

    a {
      text-decoration: none;
    }

    .description {
      color: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue